import { c as _c } from "react/compiler-runtime";
import { SidebarContent } from "@components/sidebar/sidebar-content";
import { SidebarMixins } from "@components/sidebar/sidebar-helper";
import { Drawer } from "@flat-ui";
import { useMediaQueryList } from "@hooks/use-media-query";
import { useTheme } from "@mui-wrapper";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { sidebarSelector } from "@store/ui/ui-selector";
import { updateSidebar } from "@store/ui/ui-slice";

/**
 * Handles the sidebar for mobile and desktop views
 */
export function Sidebar() {
  const $ = _c(30);
  const theme = useTheme();
  const {
    isScreenSmOrLarger
  } = useMediaQueryList();
  const dispatch = useAppDispatch();
  const {
    isFullSize,
    isOpenOnMobile
  } = useAppSelector(sidebarSelector);
  if (isScreenSmOrLarger) {
    let t0;
    if ($[0] !== isFullSize || $[1] !== theme) {
      t0 = isFullSize && {
        ...SidebarMixins.openedMixin(theme),
        "& .MuiDrawer-paper": SidebarMixins.openedMixin(theme)
      };
      $[0] = isFullSize;
      $[1] = theme;
      $[2] = t0;
    } else {
      t0 = $[2];
    }
    let t1;
    if ($[3] !== isFullSize || $[4] !== theme) {
      t1 = !isFullSize && {
        ...SidebarMixins.closedMixin(theme),
        "& .MuiDrawer-paper": SidebarMixins.closedMixin(theme)
      };
      $[3] = isFullSize;
      $[4] = theme;
      $[5] = t1;
    } else {
      t1 = $[5];
    }
    let t2;
    if ($[6] !== t0 || $[7] !== t1) {
      t2 = {
        flexShrink: 0,
        whiteSpace: "nowrap",
        boxSizing: "border-box",
        ...t0,
        ...t1
      };
      $[6] = t0;
      $[7] = t1;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    let t3;
    if ($[9] !== isFullSize) {
      t3 = <SidebarContent isSidebarFullSize={isFullSize} isSidebarMobileVersion={false} />;
      $[9] = isFullSize;
      $[10] = t3;
    } else {
      t3 = $[10];
    }
    let t4;
    if ($[11] !== isFullSize || $[12] !== t2 || $[13] !== t3) {
      t4 = <Drawer variant="permanent" dataTestId="SIDEBAR_CONTAINER" open={isFullSize} sx={t2}>{t3}</Drawer>;
      $[11] = isFullSize;
      $[12] = t2;
      $[13] = t3;
      $[14] = t4;
    } else {
      t4 = $[14];
    }
    return t4;
  }
  let t0;
  if ($[15] !== dispatch) {
    t0 = () => dispatch(updateSidebar({
      isOpenOnMobile: false
    }));
    $[15] = dispatch;
    $[16] = t0;
  } else {
    t0 = $[16];
  }
  let t1;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      root: {
        keepMounted: true
      }
    };
    $[17] = t1;
  } else {
    t1 = $[17];
  }
  let t2;
  if ($[18] !== theme) {
    t2 = SidebarMixins.openedMixin(theme);
    $[18] = theme;
    $[19] = t2;
  } else {
    t2 = $[19];
  }
  let t3;
  if ($[20] !== theme) {
    t3 = SidebarMixins.openedMixin(theme);
    $[20] = theme;
    $[21] = t3;
  } else {
    t3 = $[21];
  }
  let t4;
  if ($[22] !== t2 || $[23] !== t3) {
    t4 = {
      ...{
        ...t2,
        "& .MuiDrawer-paper": t3
      }
    };
    $[22] = t2;
    $[23] = t3;
    $[24] = t4;
  } else {
    t4 = $[24];
  }
  let t5;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <SidebarContent isSidebarFullSize={true} isSidebarMobileVersion={true} />;
    $[25] = t5;
  } else {
    t5 = $[25];
  }
  let t6;
  if ($[26] !== isOpenOnMobile || $[27] !== t0 || $[28] !== t4) {
    t6 = <Drawer variant="temporary" anchor="left" open={isOpenOnMobile} onClose={t0} slotProps={t1} sx={t4}>{t5}</Drawer>;
    $[26] = isOpenOnMobile;
    $[27] = t0;
    $[28] = t4;
    $[29] = t6;
  } else {
    t6 = $[29];
  }
  return t6;
}